import { RefresherEventDetail } from '@ionic/core';

export const isIonRefresherEvent = (event: Event | undefined): event is CustomEvent<RefresherEventDetail> =>
  event !== undefined && 'detail' in event;
